import { render, staticRenderFns } from "./chatdata.vue?vue&type=template&id=2a9b9f8e&scoped=true"
import script from "./chatdata.vue?vue&type=script&lang=js"
export * from "./chatdata.vue?vue&type=script&lang=js"
import style0 from "./chatdata.vue?vue&type=style&index=0&id=2a9b9f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b9f8e",
  null
  
)

export default component.exports